export default "__VITE_ASSET__63ae96c5__"